import { enUS, esES } from '@/locales'
import { useStorage } from '@vueuse/core'
import { createI18n } from 'vue-i18n'

const savedLocale = useStorage('locale', 'en-US')

export const i18n = createI18n({
  locale: savedLocale.value,
  fallbackLocale: 'en-US',
  legacy: false,
  globalInjection: true,
  messages: {
    'en-US': enUS,
    'es-ES': esES,
  },
})
